import { sendGetRequest } from '@vh/services/PDService';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { virtualHumanDataSelector } from '@vh/slices/VirtualHumanSlice';
import { useLocation } from 'react-router-dom';
import { isPublicVHPlayerPage } from '@base/utility/VirtualHumanUtility';
import { useInjectedVHTypeConfig } from '@vh/components/vh-types/vhTypeHooks';

/** @type {(vhId: number, vhType: string)=> [boolean, boolean]} */
export const useVhReady = (vhId, vhType) => {
  const [ready, setReady] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);
  const { ShareToken } = useSelector(virtualHumanDataSelector);
  const location = useLocation();

  const publicVH = isPublicVHPlayerPage(location);
  const { usesDialogflow } = useInjectedVHTypeConfig(vhType);

  useEffect(() => {
    setReady(false);
    let timer = 0;

    // only send req for freeform
    const sendReq = async () => {
      const checkReadyTimeoutMs = 5000;
      try {
        const res = await sendGetRequest(
          `virtual-humans/${vhId}/ready`,
          publicVH ? ShareToken : null
        );
        const ready = res?.data?.data === true;
        setHasChecked(true);
        setReady(ready);
        if (!ready) {
          timer = window.setTimeout(() => {
            sendReq();
          }, checkReadyTimeoutMs);
        }
      } catch (e) {
        timer = window.setTimeout(() => {
          sendReq();
        }, checkReadyTimeoutMs);
        Sentry.captureException(e);
      }
    };

    if (usesDialogflow) {
      sendReq();
    } else {
      setReady(true);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [vhId, vhType, ShareToken, usesDialogflow, publicVH]);

  return [ready, hasChecked];
};
